import React from 'react';

import './Footer.css';
import LogoTaf from '../../images/logo-taf.png';
import { ScrollToTop } from '../../common/ScrollToTop/ScrollToTop';

export const Footer = () => (
  <div className="footer">
    <div className="contain">
      <div className="copyright">
        <a className="footer-logo" href="https://www.taf.nl"><img src={LogoTaf} alt="TAF"/></a>
        TAF © <span>2020</span>. Alle rechten voorbehouden.
      </div>
    </div>
    <ScrollToTop/>
  </div>
);
